"use client";

import { ReactNode } from "react";
import { RadioCard } from "@leabankab/component-library";
import { FormField } from "@leabankab/component-library/react-hook-form";

type RadioCardValue = string | number | boolean;

interface RadioCardFieldProps<T extends RadioCardValue> {
	name: string;
	label: ReactNode;
	tooltip?: ReactNode;
	/** Option values are submitted as-is, so a yes/no field uses `true`/`false`. */
	options: { value: T; label: ReactNode; disabled?: boolean }[];
	columns?: number;
	className?: string;
}

/** A group of small radio cards bound to the surrounding react-hook-form form. */
export const RadioCardField = <T extends RadioCardValue>({
	name,
	label,
	tooltip,
	options,
	columns = 2,
	className,
}: RadioCardFieldProps<T>) => (
	<FormField
		name={name}
		render={({ field }) => (
			<RadioCard.Group<T>
				label={label}
				tooltip={tooltip}
				options={options}
				columns={columns}
				size="sm"
				className={className}
				{...field}
				value={field.value ?? null}
			/>
		)}
	/>
);
